<!-- eslint-disable max-len -->
<template>
<div>
  <v-alert :value="alert()" dismissible :type="alertType()">
    {{ alertMessage }}
  </v-alert>
  <v-dialog v-model="pdf_dialog">
    <v-toolbar class="py-0 subheading" dark color="primary">
      OBJETO PERDIDO
      <v-spacer></v-spacer>
      <v-btn flat icon @click="pdf_dialog=false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <embed class="hidden-md-and-down" :src="pdf_file" type="application/pdf" width="100%" height="700px"/>
  </v-dialog>
  <v-dialog v-model="dialogReporte" persistent width="700" transition="dialog-bottom-transition" >
    <v-card>
      <v-toolbar class="py-0 subheading" dark color="primary">
        AGREGAR OBJETO PERDIDO
        <v-spacer></v-spacer>
        <v-btn flat icon @click="dialogReporte=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container grid-list-md fluid>
        <v-form
          ref="form"
          name="avisoForm"
          v-model="valid"
          lazy-validation
        >
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field
                v-model="titulo_reglamento"
                label="Título"
                single-line
                required
                :rules="title_rules"
                hide-details
              />
            </v-flex>
            <v-flex xs12 sm12 md12>
              <p v-if="file_error" style="color:red;">{{file_error}}</p>
              <p>* se requiere un archivo PDF no mayor a 3MB</p>
              <input required type="file" v-show="true" ref="inputUpload" accept="application/pdf" 
                id="aviso_file" color="primary" name="aviso_file">
            </v-flex>
            <v-flex xs12 sm12 md12 class="mt-1">
              <div class="text-xs-center">
                <v-btn color="primary" v-if="send_button" @click="validate" class="mt-2">
                  AGREGAR
                </v-btn>
                <v-progress-circular v-else :indeterminate="true" color="primary">
                </v-progress-circular>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
  <v-card-title>
    <v-btn color="primary" @click="dialogReporte=true">
      AGREGAR OBJETO PERDIDO
    </v-btn>
    <v-spacer/>
    <!--
      <v-text-field v-model="presearch" append-icon="search" label="Buscar" single-line hide-details />
    -->
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="rowItems"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td  class="text-xs-left px-2">
            {{ props.item.reglamento_id }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.titulo }}
          </td>
          <td   class="text-xs-left px-2">
            {{ props.item.creado }}
          </td>
          <td   class="text-xs-left px-2">
            <v-btn color="primary"
                   @click="show_pdf(props.item.adjunto)" class="mt-2">
                  VER ARCHIVO
                </v-btn>
          </td>
          <td   class="text-xs-left px-2">
            <v-btn color="primary"
                   @click="delete_reglamento(props.item.reglamento_id)" class="mt-2">
                  ELIMINAR
                </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

// eslint-disable-next-line camelcase

export default {
  data: () => ({
    pdf_dialog: false,
    pdf_file: null,
    selected_aviso: null,
    send_dialog: false,
    aviso_form: {},
    send_button: true,
    send_disabled: true,
    file_error: null,
    title_rules: [v => !!v || 'Campo Requerido'],
    titulo_reglamento: '',
    aviso_file: [],
    valid: false,
    presearch: '',
    searchTimer: null,
    search: '',
    menu_fecha_desde: false,
    fecha_desde: null,
    menu_fecha_hasta: false,
    fecha_hasta: null,
    dialogReporte: false,
    rowItems: [],
    pagination: {},
    totalItems: 0,
    loading: false,
    headers: [
      {
        text: 'ID', value: 'reglamento_id', sortable: false,
      },
      {
        text: 'TÍTULO', value: 'titulo', sortable: false,
      },
      {
        text: 'CREADO', value: 'creado', sortable: false,
      },
      {
        text: 'ACCIONES', value: 'acciones', sortable: false,
      },
    ],
  }),
  created() {
    // this.getReportFromApi();
    // this.getSubcondominios();
  },
  methods: {
    alertType() {
      return this.$store.getters['reglamentos/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['reglamentos/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['reglamentos/alertContainer'];
    },
    show_pdf(avisoFile) {
      this.$store.dispatch('reglamentos/obtenerArchivoReglamento', avisoFile).then((data) => {
        this.pdf_file = URL.createObjectURL(data);
        this.pdf_dialog = true;
      });
    },
    delete_reglamento(reglamentoId) {
      this.$store.dispatch('reglamentos/deleteReglamento', reglamentoId).then(() => {
        this.fetchReglamentos();
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        if (this.$refs.inputUpload.files.length > 0) {
          if (this.$refs.inputUpload.files[0].size > 1024 * 1024 * 3) {
            this.file_error = 'el archivo no puede ser mayor a 3MB';
          } else {
            // const formdata = new FormData(document.forms.namedItem('avisoForm'));
            const formdata = new FormData();
            formdata.append('aviso_file', this.$refs.inputUpload.files[0]);
            formdata.append('titulo', this.titulo_reglamento);
            this.send_button = false;
            this.$store.dispatch('reglamentos/createReglamento', formdata).then(() => {
              this.file_error = null;
              this.titulo_reglamento = '';
              this.send_button = true;
              this.dialogReporte = false;
              this.fetchReglamentos();
            });
          }
        } else {
          this.file_error = 'Se requiere proporcionar un archivo PDF no mayor a 3MB';
        }
      }
    },
    fetchReglamentos() {
      this.loading = true;
      const {
        sortBy, descending, page, rowsPerPage,
      } = this.pagination;

      const formdata = {
        page,
        per_page: rowsPerPage,
        search: this.search,
        order_by: sortBy,
        descending,
      };
      this.$store.dispatch('reglamentos/fetchReglamentos', formdata)
        .then((data) => {
          this.totalItems = data.total;
          this.rowItems = data.reglamentos;
          this.loading = false;
        });
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchReglamentos();
      },
      deep: true,
    },
    search() {
      this.fetchReglamentos();
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
};
</script>

<style scoped>

</style>
